// extracted by mini-css-extract-plugin
export default {"icon":"ActiveIcon_icon__nvTA+"};